// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"header___3b6d9","title":"title___1Em9G","body":"body___1XVKi"};